var productContainer = document.createElement('div');
productContainer.innerHTML = $('.blog-related-products').html();

let isFirstImage = true;

$('.article-content img').each(function(index, item) {
    if (isFirstImage) {
        isFirstImage = false;
        return true; // Skip the first image
    }

    index++;
    const classitem = '.blogInnerContent_' + index;
    const html = productContainer.querySelector(`${classitem}`).innerHTML;

    if (html != '') {
        $(this).after(html);
        $(this).remove();
    }
});